module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/command-center-lvl3-50.adea14a5.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/command-center-lvl3-50.png
// module id = 3521
// module chunks = 11